import type { CompanyAccountListQuery, Page } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { Landmark, SearchX } from 'lucide-react';
import { EmptyState } from '../../../shared/components/EmptyState';
import { ListSearch } from '../../../shared/components/ListSearch';
import type { ListQueryControls } from '../../../shared/hooks/use-list-query';
import type { CompanyAccountView } from '../company-accounts.api';

interface CompanyAccountsTableProps {
  page: Page<CompanyAccountView>;
  columns: TableColumnsType<CompanyAccountView>;
  list: ListQueryControls<CompanyAccountListQuery>;
  isRefreshing: boolean;
}

/** Search and the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function CompanyAccountsTable({ page, columns, list, isRefreshing }: CompanyAccountsTableProps) {
  const emptyText = list.isFiltered ? <NoMatchingAccounts /> : <NoAccountsYet />;

  return (
    <div className="flex flex-col gap-4">
      <ListSearch value={list.query.q} placeholder="Search name, bank or number" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
      <Table
        rowKey="id"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={{ emptyText }}
        {...list.tableProps<CompanyAccountView>(page.total)}
      />
    </div>
  );
}

function NoMatchingAccounts() {
  return <EmptyState icon={SearchX} title="No matching accounts" description="No accounts match this search or these filters." />;
}

function NoAccountsYet() {
  return (
    <EmptyState icon={Landmark} title="No accounts yet" description="Add the bank accounts and M-Pesa numbers customers pay into, so receipts can name them." />
  );
}
